export default {
  index: [
    {
      path: '/ptsrl',
      component: resolve => require(['./ptsrlIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/pt_srl/_router.js